export default "__VITE_ASSET__BWi5qogp__"